import PropTypes from "prop-types";
import React from "react";
import AgentForceChatBotContainer from ".";

function AFChatOption({ config: { open, displayTimes, percentage } }) {
  const getIfEnabled = () => Math.random() < percentage / 100;

  const getChatDOM = () => {
    if (!getIfEnabled()) {
      return null;
    }
    return <AgentForceChatBotContainer open={open} displayTimes={displayTimes} />;
  };

  return getChatDOM();
}

AFChatOption.propTypes = {
  config: PropTypes.shape({
    channel: PropTypes.string,
    open: PropTypes.bool,
    displayTimes: PropTypes.arrayOf(
      PropTypes.shape({
        order: PropTypes.number,
        days: PropTypes.string,
        times: PropTypes.string,
      }),
    ),
    percentage: PropTypes.number,
  }).isRequired,
};

export default AFChatOption;
